import { IInitialStateSetAction } from './types';
import { AT_INITIAL_STATE_SET } from './constants';

export const initialStateSet =
(): IInitialStateSetAction => ({
    type: AT_INITIAL_STATE_SET
});
